import React from 'react';

// ErrorBoundary por pestaña. Aisla fallos de render/fetch de un componente
// para que el resto de la app (sidebar, header, otras pestañas) siga operativa.
// Uso: <ErrorBoundary view="emergencias"><CodigosRojos/></ErrorBoundary>
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // En prod esto se podría mandar a Sentry/LogRocket
    console.error(`[ErrorBoundary:${this.props.view || 'root'}]`, error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div style={{
        padding: 32, maxWidth: 560, margin: '48px auto',
        background: 'var(--bg-card, #fff)',
        border: '1px solid var(--border-soft, #e8e6e0)', borderRadius: 12,
        fontSize: 13, color: 'var(--text-soft, #5f5e5a)',
      }}>
        <div style={{
          fontSize: 14, fontWeight: 600, color: 'var(--sev-critico, #791f1f)',
          marginBottom: 8,
        }}>
          Algo salió mal en esta vista
        </div>
        <div style={{ marginBottom: 16 }}>
          La sección <b>{this.props.view || 'actual'}</b> no se pudo renderizar.
          El resto de la app sigue funcionando: navega con la barra lateral.
        </div>
        <details style={{ marginBottom: 16, fontFamily: 'monospace', fontSize: 11, color: 'var(--text-muted, #888780)' }}>
          <summary style={{ cursor: 'pointer', marginBottom: 6 }}>Detalle técnico</summary>
          <div style={{
            padding: 10, background: 'var(--bg-muted, #f5f4f0)', borderRadius: 6,
            whiteSpace: 'pre-wrap', wordBreak: 'break-word',
          }}>{msg}</div>
        </details>
        <button
          onClick={this.reset}
          style={{
            padding: '8px 14px', border: '1px solid var(--border-soft, #e8e6e0)',
            background: 'var(--bg-muted, #f5f4f0)', borderRadius: 8, cursor: 'pointer',
            fontSize: 12, fontWeight: 500, color: 'var(--text-strong, #3a3937)',
          }}
        >
          Reintentar
        </button>
      </div>
    );
  }
}
